import { useState, useEffect, useCallback } from 'react'
import { HiOutlinePlus } from 'react-icons/hi2'

import { ListEvaluation } from './ListEvaluation'

import { ModalEvaluation360 } from './ModalCreate'
import Loading from '../Loading/Loading'

import { evaluation360 } from '../../i18n/translatedMessages'

import Evaluation360 from '../../API/Evaluation/Evaluation360'

export function Main() {
	const [show, setShow] = useState(false)
	const [loading, setLoading] = useState(true)
	const [inputFilter, setInputFilter] = useState('')

	const [templates, setTemplates] = useState(null)

	const { id } = JSON.parse(localStorage.getItem('user'))

	const loadData = useCallback(async () => {
		try {
			const response = await Evaluation360.getAllTemplateByCompany(id)

			setTemplates(response)
		} catch (error) {
			console.error('Load Data: getAllEmployeeByTemplate: ', error)
		} finally {
			setLoading(false)
		}
	}, [])

	const filterOnChange = async event => {
		setInputFilter(event.target.value)

		try {
			const response = await Evaluation360.getAllTemplateByCompany(id, `query=${event.target.value}`)
			setTemplates(response)
		} catch (error) {}
	}

	useEffect(() => {
		loadData()
	}, [loadData])

	if (loading) return <Loading />

	return (
		<div>
			<h3 className='tw-font-bold tw-mb-4'>{evaluation360.evaluationTitle}</h3>
			<div className='tw-text-base tw-mb-4'>{evaluation360.evaluationDescription}</div>

			<div className='tw-flex tw-gap-2 tw-items-center tw-pr-9'>
				<input
					value={inputFilter}
					onChange={filterOnChange}
					type='text'
					className='tw-h-[32px] tw-w-full border'
					placeholder='Buscar'
					style={{ borderRadius: 6 }}
				/>
				<button className='tw-h-[38px] tw-bg-white tw-w-52 border tw-rounded-md'>{evaluation360.btnCleanFilters}</button>
				<button
					className='tw-h-[38px] tw-bg-purple tw-text-white tw-w-64 border-0 tw-rounded-md active:tw-bg-purple-600'
					onClick={() => setShow(true)}
				>
					<HiOutlinePlus />
					{evaluation360.btnCreateEvaluation}
				</button>
			</div>
			<div className='tw-mr-4 tw-h-[600px] tw-overflow-y-scroll tw-pr-4'>
				{templates && templates.length !== 0 ? (
					<ListEvaluation templates={templates} />
				) : (
					<div className='tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center border tw-bg-gray-100 tw-rounded-md tw-text-gray-600'>
						{evaluation360.labelThereAreNotTempleatesCreated}
					</div>
				)}
			</div>
			<ModalEvaluation360 setShow={setShow} show={show} load={loadData} />
		</div>
	)
}
